import { render, staticRenderFns } from "./MypagePointExpirationDatePage.vue?vue&type=template&id=1e7e34c5&scoped=true"
import script from "./MypagePointExpirationDatePage.vue?vue&type=script&lang=ts"
export * from "./MypagePointExpirationDatePage.vue?vue&type=script&lang=ts"
import style0 from "./MypagePointExpirationDatePage.vue?vue&type=style&index=0&id=1e7e34c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7e34c5",
  null
  
)

export default component.exports